import * as React from "react"

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  isSmall?: boolean
}

const Container: React.FC<IProps> = ({
  children,
  className,
  isSmall = false,
  ...props
}) => (
  <div className={`container px-4 ${className ?? ""}`} {...props}>
    <>
      {isSmall ? (
        <div className="common-center-container">{children}</div>
      ) : (
        children
      )}
    </>
  </div>
)

export default Container
